import React from 'react';
import { usePageTitle } from '../../hooks/usePageTitle';
import PageLayout from '../../layouts/PageLayout';
import { Section, SectionHeader } from '../../components/shared/Section';
import DomainSections from './components/DomainSections';
import { cn } from '../../lib/utils';
import { getThemeClass } from '../../lib/theme';
import { HeroRibbon } from '../Home/components/HeroSection';

const Journey: React.FC = () => {
  usePageTitle('Professional Journey');

  return (
    <PageLayout>
      {/* Hero Section */}
      <HeroRibbon
        title="Professional Journey"
        subtitle="A track record of transforming complex technical challenges into scalable, 
              efficient solutions across multiple domains. Each section represents a key 
              area of expertise with integrated innovations and measurable impact."
      />
        <DomainSections />        
    </PageLayout>
  );
};

export default Journey;